import { postIncidentLogExportStart } from '@api';

import { createPostAsyncSlice, SagaYieldType } from '@sonar-software/xuder';

export const postCoreDataSecurityIncidentLogExportSlice = createPostAsyncSlice({
	name: 'CoreDataSecurityIncidentLogExport',
	receive: true,
	request: true,
	requestHandler: postIncidentLogExportStart,
	retainDataOnRequest: false,
	yieldType: SagaYieldType.Every
});
